document.addEventListener('DOMContentLoaded', function () {
  var form = document.querySelector('.search-form');
  if (!form) return;

  var input = form.querySelector('input[type="search"]');
  if (!input) return;

  var wrap = document.createElement('div');
  wrap.id = 'predictive-search';
  form.parentNode.insertBefore(wrap, form);
  wrap.appendChild(form);

  var results = document.createElement('div');
  results.id = 'predictive-search-results';
  results.innerHTML = '<ul></ul>';
  wrap.appendChild(results);

  var ul = results.querySelector('ul');
  var timeout;

  input.addEventListener('input', function () {
    clearTimeout(timeout);
    var q = this.value.trim();
    if (q.length < 2) {
      results.classList.remove('open');
      ul.innerHTML = '';
      return;
    }

    timeout = setTimeout(function () {
      fetch(`/search/suggest.json?q=${encodeURIComponent(q)}&resources[type]=product&resources[limit]=6`)
        .then((r) => r.json())
        .then((data) => {
          var products = (data.resources?.results?.products) || [];
          ul.innerHTML = '';

          if (!products.length) {
            results.classList.remove('open');
            return;
          }

          // === Build Product Results ===
          products.forEach((p) => {
            var li = document.createElement('li');
            li.innerHTML = `
              <a href="${p.url}" class="result-item" style="display:flex;align-items:center;gap:10px;text-decoration:none;color:#fff;padding:8px 10px;">
                ${p.image ? `<img src="${p.image}" alt="${p.title}" style="width:50px;height:50px;object-fit:cover;border-radius:6px;">` : ''}
                <div style="flex:1;">
                  <div style="font-weight:600;">${p.title}</div>
                  ${p.price ? `<div style="color:#16a34a;">${p.price}</div>` : ''}
                </div>
              </a>
            `;
            ul.appendChild(li);
          });

          // === Add “See More” Button ===
          var seeMore = document.createElement('li');
          seeMore.innerHTML = `
            <a href="/search?q=${encodeURIComponent(q)}" 
              style="display:block;text-align:center;padding:10px 0;color:#16a34a;font-weight:bold;text-decoration:none;">
              See more results →
            </a>`;
          ul.appendChild(seeMore);

          results.classList.add('open');
        })
        .catch(() => {
          results.classList.remove('open');
          ul.innerHTML = '';
        });
    }, 150);
  });

  // Close dropdown when clicking outside
  document.addEventListener('click', function (e) {
    if (!wrap.contains(e.target)) {
      results.classList.remove('open');
    }
  });
});
